<template>
  <div class="table-responsive">
    <table class="table">
      <tbody>
        <tr>
          <td v-if="1 === exchangeId && isDesktop" class="exchange-brand-cell">
            <div class="exchange-brand">
              <img class="exchange-logo" src="@/assets/images/XBUL.svg" alt="Bulgarian Stock Exchange">
              <p class="exchange-name"><b>{{ exchangeDisplayName }}</b></p>
            </div>
          </td>
          <td v-if="2 === exchangeId && isDesktop" class="exchange-brand-cell">
            <div class="exchange-brand">
              <img class="exchange-logo" src="@/assets/images/Deutsche-Boerse_Logo.svg" alt="Deutsche Börse Xetra">
              <p class="exchange-name"><b>{{ exchangeDisplayName }}</b></p>
            </div>
          </td>
          <td v-if="3 === exchangeId && isDesktop" class="exchange-brand-cell">
            <div class="exchange-brand">
              <img class="exchange-logo" src="@/assets/images/Deutsche-Boerse_Logo.svg" alt="Deutsche Börse Frankfurt">
              <p class="exchange-name"><b>{{ exchangeDisplayName }}</b></p>
            </div>
          </td>
          <td>
            <div v-if="1 === exchangeId && !isDesktop">
              <div class="exchange-brand exchange-brand-mobile">
                <img class="exchange-logo" src="@/assets/images/XBUL.svg" alt="Bulgarian Stock Exchange">
                <p class="exchange-name"><b>{{ exchangeDisplayName }}</b></p>
              </div>
            </div>
            <div v-if="2 === exchangeId && !isDesktop">
              <div class="exchange-brand exchange-brand-mobile">
                <img class="exchange-logo" src="@/assets/images/Deutsche-Boerse_Logo.svg" alt="Deutsche Börse Xetra">
                <p class="exchange-name"><b>{{ exchangeDisplayName }}</b></p>
              </div>
            </div>
            <div v-if="3 === exchangeId && !isDesktop">
              <div class="exchange-brand exchange-brand-mobile">
                <img class="exchange-logo" src="@/assets/images/Deutsche-Boerse_Logo.svg" alt="Deutsche Börse Frankfurt">
                <p class="exchange-name"><b>{{ exchangeDisplayName }}</b></p>
              </div>
            </div>
            <br />
            <table class="table exchange-breakdown-summary-table">
              <tbody>
                <tr>
                  <td v-if="isDesktop">{{ labels.balance }}</td>
                  <td v-else :class="smallTextClass">{{ labels.balance }}</td>
                  <td class="equity_align_right_heavy" :class="smallTextClass">
                    {{ formatPrice(equitiesValueInBaseCurrency, currency).replace(' ', '&nbsp;') }}
                  </td>
                </tr>
                <tr>
                  <td :class="smallTextClass">{{ labels.instruments }}</td>
                  <td class="equity_align_right_heavy" :class="smallTextClass">
                    {{ parseNumber(positionsCount, 0) }}
                  </td>
                </tr>
                <tr v-if="0 < parseFloat(equitiesValue)">
                  <td :class="smallTextClass">{{ labels.return }}</td>
                  <td v-if="returnValue > 0" class="greenColor equity_align_right_heavy" :class="smallTextClass">
                    <span class="return-value-with-icon">
                      +{{ parseNumber(baseReturnValue) }} (+{{ parseNumber(returnPercent) }}%)
                      <img class="quote-change-icon" :src="quoteUpIcon" alt="">
                    </span>
                  </td>
                  <td v-if="returnValue < 0" class="redColor equity_align_right_heavy" :class="smallTextClass">
                    <span class="return-value-with-icon">
                      {{ parseNumber(baseReturnValue) }} ({{ parseNumber(returnPercent) }}%)
                      <img class="quote-change-icon" :src="quoteDownIcon" alt="">
                    </span>
                  </td>
                </tr>
                <tr v-else>
                  <td :class="smallTextClass">{{ labels.return }}</td>
                  <td class="equity_align_right_heavy" :class="smallTextClass">
                    {{ parseNumber(baseReturnValue) }} ({{ parseNumber(0) }}%)
                  </td>
                </tr>
                <tr v-if="!isNaN(sharesCount)">
                  <td :class="smallTextClass">{{ labels.positionsBalance }}</td>
                  <td v-if="0 !== equitiesValue && 0 !== allExchangesEquitiesValue" class="equity_align_right_heavy" :class="smallTextClass">
                    <span class="progress-meter-value">
                      <meter :value="positionsBalancePercent" min="0" max="100"></meter>
                      <span class="progress-percent">{{ parseNumber(positionsBalancePercent) }}%</span>
                    </span>
                  </td>
                  <td v-else class="equity_align_right_heavy" :class="smallTextClass">
                    <span class="progress-meter-value">
                      <meter value="0" min="0" max="100"></meter>
                      <span class="progress-percent">{{ parseNumber(0) }}%</span>
                    </span>
                  </td>
                </tr>
                <tr v-else>
                  <td colspan="2" :class="smallTextClass">
                    <meter value="0" min="0" max="100"></meter>&nbsp;0%
                  </td>
                </tr>
                <tr v-if="!isNaN(sharesCount)">
                  <td :class="smallTextClass">{{ labels.totalBalance }}</td>
                  <td v-if="0 !== equitiesValue && 0 !== totalBalance" class="equity_align_right_heavy" :class="smallTextClass">
                    <span class="progress-meter-value">
                      <meter :value="totalBalancePercent" min="0" max="100"></meter>
                      <span class="progress-percent">{{ parseNumber(totalBalancePercent) }}%</span>
                    </span>
                  </td>
                  <td v-else class="equity_align_right_heavy" :class="smallTextClass">
                    <span class="progress-meter-value">
                      <meter value="0" min="0" max="100"></meter>
                      <span class="progress-percent">{{ parseNumber(0) }}%</span>
                    </span>
                  </td>
                </tr>
                <tr v-else>
                  <td colspan="2" :class="smallTextClass">
                    <meter value="0" min="0" max="100"></meter>&nbsp;0%
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { getExchangeDisplayName } from "@/assets/js/exchange_labels.js";
import quoteDownIcon from "@/assets/images/Quote-Down.svg";
import quoteUpIcon from "@/assets/images/Quote-Up.svg";

export default {
  props: {
    exchangeId: { type: Number, required: true },
    windowWidth: { type: Number, required: true },
    labels: { type: Object, required: true },
    currency: { type: String, required: true },
    exchangeCurrency: { type: String, required: true },
    equitiesValue: { type: [Number, String], required: true },
    equitiesValueInBaseCurrency: { type: [Number, String], required: true },
    equitiesValueInExchangeCurrency: { type: [Number, String], required: true },
    averageEquitiesValue: { type: [Number, String], required: true },
    averageEquitiesValueInBaseCurrency: { type: [Number, String], required: true },
    positionsCount: { type: [Number, String], required: true },
    sharesCount: { type: [Number, String], required: true },
    allExchangesEquitiesValue: { type: [Number, String], required: true },
    totalBalance: { type: [Number, String], required: true },
    formatPrice: { type: Function, required: true },
    parseNumber: { type: Function, required: true }
  },
  computed: {
    quoteDownIcon() {
      return quoteDownIcon;
    },
    quoteUpIcon() {
      return quoteUpIcon;
    },
    isDesktop() {
      return 1200 < this.windowWidth;
    },
    smallTextClass() {
      return { 'xsmall-font-size': !this.isDesktop };
    },
    exchangeCode() {
      return {
        1: "XBUL",
        2: "XETR",
        3: "XFRA"
      }[this.exchangeId] || "";
    },
    exchangeDisplayName() {
      return getExchangeDisplayName(this.exchangeCode, this.$store.getters["getUserLanguage"]);
    },
    returnValue() {
      return this.equitiesValue - this.averageEquitiesValue;
    },
    baseReturnValue() {
      return this.equitiesValueInBaseCurrency - this.averageEquitiesValueInBaseCurrency;
    },
    returnPercent() {
      return (this.returnValue / this.averageEquitiesValue) * 100;
    },
    positionsBalancePercent() {
      return this.clampPercent(this.equitiesValue / this.allExchangesEquitiesValue * 100);
    },
    totalBalancePercent() {
      return this.clampPercent(this.equitiesValue / this.totalBalance * 100);
    }
  },
  methods: {
    clampPercent(value) {
      const percent = parseFloat(value);
      return Number.isFinite(percent) ? Math.min(Math.max(percent, 0), 100) : 0;
    }
  }
};
</script>

<style scoped>
.equity_align_right_heavy {
  font-weight: bold;
  vertical-align: middle;
  text-align: right;
}

.table.exchange-breakdown-summary-table > tbody > tr > td {
  font-size: 1rem;
  line-height: 1.35;
  padding: 0.75rem 0.5rem 0.45rem;
  vertical-align: middle;
}

.exchange-breakdown-summary-table > tbody > tr > td:first-child {
  white-space: nowrap;
}

.progress-meter-value {
  align-items: center;
  display: inline-flex;
  gap: 0.25rem;
  white-space: nowrap;
}

.progress-percent {
  display: inline-block;
  min-width: 3.75rem;
  text-align: right;
}

.greenColor {
  color: #189e18;
}

.redColor {
  color: #ff0000;
}

.quote-change-icon {
  height: 12px;
  margin-left: 0;
  transform: translateY(-1px);
  width: 12px;
}

.return-value-with-icon {
  align-items: center;
  display: inline-flex;
  gap: 0.15rem;
}

.exchange-brand-cell {
  vertical-align: middle;
  width: 38%;
}

.exchange-brand {
  align-items: center;
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  min-height: 13rem;
  padding: 1rem;
  text-align: center;
}

.exchange-brand-mobile {
  min-height: auto;
  padding: 0.5rem 0;
}

.exchange-logo {
  flex: 0 0 auto;
  height: 72px;
  width: 72px;
  object-fit: contain;
}

.exchange-name {
  font-size: 1.25rem;
  line-height: 1.25;
  margin: 0;
}

.xsmall-font-size {
  font-size: x-small;
}
</style>
